import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class DepartmentStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
